import { createStore } from 'vuex'

export default createStore({
  state: {
    toasts: [],
    cartCount: (() => {
      try {
        const cart = JSON.parse(localStorage.getItem('cart') || '[]');
        return cart.reduce((acc, item) => acc + (item.quantity || 0), 0);
      } catch (e) {
        return 0;
      }
    })()
  },
  getters: {
    activeToasts: (state) => state.toasts,
    cartCount: (state) => state.cartCount
  },
  mutations: {
    ADD_TOAST(state, toast) {
      state.toasts.push(toast);
    },
    REMOVE_TOAST(state, id) {
      state.toasts = state.toasts.filter(toast => toast.id !== id);
    },
    UPDATE_CART_COUNT(state) {
      try {
        const cart = JSON.parse(localStorage.getItem('cart') || '[]');
        state.cartCount = cart.reduce((acc, item) => acc + (item.quantity || 0), 0);
      } catch (e) {
        state.cartCount = 0;
      }
    }
  },
  actions: {
    showToast({ commit }, { message, type = 'success', title = '', duration = 3000 }) {
      const id = Date.now() + Math.random().toString(36).substr(2, 9);
      commit('ADD_TOAST', { id, message, type, title, duration });
      
      if (duration > 0) {
        setTimeout(() => {
          commit('REMOVE_TOAST', id);
        }, duration);
      }
    },
    removeToast({ commit }, id) {
      commit('REMOVE_TOAST', id);
    }
  },
  modules: {
  }
})
